// types we need inside app
export enum Namespace {
  translation = 'translation',
}

// value should match with folder name
export enum Language {
  English = 'en',
  Arabic = 'ar',
  Bulgarian = 'bg',
  Catalan = 'ca',
  Czech = 'cs',
  Danish = 'da',
  DutchBelgium = 'nl-BE',
  DutchNetherlands = 'nl-NL',
  Finnish = 'fi',
  German = 'de',
  Spanish = 'es',
  French = 'fr',
  Croatian = 'hr',
  Hungarian = 'hu',
  Italian = 'it',
  Japanese = 'ja',
  Norwegian = 'no',
  Polish = 'pl',
  Portuguese = 'pt',
  PortugueseBrazil = 'pt-BR',
  Romanian = 'ro',
  Russian = 'ru',
  Slovenian = 'sl',
  Swedish = 'sv',
  Thai = 'th',
  Turkish = 'tr',
  Ukrainian = 'uk',
  Chinese = 'zh',
}
